export enum BonusAmountType {
  PERCENTAGE = 1,
  FIXED = 2,
  FREE_SPINS_AMOUNT = 3,
}
